export default function getConditionReportOptions() {
    const conditionReportOptions = [];

    for (let i = 0; i <= 5; i += 0.1) {
        const value = Number(i.toFixed(2));

        conditionReportOptions.push({
            value,
            label: value,
        });
    }

    return conditionReportOptions;
}
